import * as accordionDropdown from './Eventlisteners/accordionDropdown.js';
import * as headerScrollUp from './Eventlisteners/headerScrollUp.js';
import * as cookieBanner from './Eventlisteners/cookieBanner.js';

export const init = () => {
    accordionDropdown.init();
    cookieBanner.init();
    headerScrollUp.init();
}